import { gql } from '@apollo/client';
import { type DocumentNode } from 'graphql';

export const COMMUNITY_STATUS_RESET: DocumentNode = gql`
  mutation resetCommunityRemovalStatus($communityId: Int!) {
    resetCommunityRemovalStatus(communityId: $communityId)
  }
`;
